import React, { useEffect, useRef, useState } from 'react';

/**
 * OnTurkiyeDeck: glowy tanıtım sunumu (İngilizce, "agency profile").
 * Route: /hq/on-turkiye (ProtectedRoute allowEmails, sadece sahibine açık)
 *
 * 10 slaytlık statik sunum, sabit 16:9 dikdörtgen. API çağrısı yok, marka seçimi gerekmiyor.
 * Ok tuşlarıyla ilerler, tarayıcıdan yazdırınca her slayt ayrı sayfa olur.
 *
 * Deck iframe içinde çalışır: kendi CSS'i `:root`, `.card` gibi global seçiciler ve
 * `position:fixed` kuralları içeriyor, srcDoc izolasyonu uygulamanın geri kalanını korur.
 *
 * HTML modülü ~840KB (gömülü fontlar, logolar ve iki tam kanvas fotoğraf). Statik import
 * ana bundle'ı şişirdiği için sadece bu sayfa açıldığında dinamik olarak yükleniyor.
 */
export default function OnTurkiyeDeck() {
  const frameRef = useRef(null);
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./onTurkiyeDeckHtml')
      .then((mod) => {
        if (alive) setHtml(mod.default);
      })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px">Sunum yüklenemedi.</p>');
      });
    return () => {
      alive = false;
    };
  }, []);

  // Ok tuşları iframe'e odak gelmeden çalışmaz; sayfa açılır açılmaz odağı içeri veriyoruz.
  useEffect(() => {
    const frame = frameRef.current;
    if (!frame) return undefined;
    const focusDeck = () => {
      try {
        frame.contentWindow?.focus();
      } catch (err) {
        /* farklı origin değil ama yine de sessiz geç */
      }
    };
    frame.addEventListener('load', focusDeck);
    return () => frame.removeEventListener('load', focusDeck);
  }, [html]);

  const fill = {
    position: 'fixed',
    inset: 0,
    width: '100vw',
    height: '100vh',
    border: 0,
  };

  if (!html) return <div style={{ ...fill, background: '#E7E7EC' }} />;

  return <iframe ref={frameRef} title="On Türkiye · glowy sunum" srcDoc={html} style={fill} />;
}
